import { Pipe, PipeTransform } from '@angular/core';
import { PropertyType } from '../engine/property-type.enum';
import { ModelProperty } from '../engine/model-property';

@Pipe({
  name: 'stripHtml',
  standalone: true,
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string, model?: ModelProperty): unknown {
    if ((model && model.editType === PropertyType.richText) || !model) {
      const tmp = document.createElement('div');
      tmp.innerHTML = value;
      return tmp.textContent || tmp.innerText || '';
    }
    return value;
  }
}
